import { render, staticRenderFns } from "./SearchPsychologistComponent.vue?vue&type=template&id=011fb15b&scoped=true&"
import script from "./SearchPsychologistComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchPsychologistComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPsychologistComponent.vue?vue&type=style&index=0&id=011fb15b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011fb15b",
  null
  
)

export default component.exports